import { forwardRef, type SVGProps } from 'react';

export const Bell = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} {...props} fillRule="evenodd" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.318 21.417l-1.782-2.963a8.787 8.787 0 01-1.258-4.529v-2.596a7.241 7.241 0 00-3.64-6.275 7.783 7.783 0 00-.978-.45.906.906 0 01-.571-.842V2.529a2.076 2.076 0 00-4.152 0v1.23a.906.906 0 01-.575.843 7.55 7.55 0 00-.839.376 7.244 7.244 0 00-3.775 6.351v2.596c0 1.595-.435 3.16-1.257 4.528l-1.782 2.963a.514.514 0 00-.006.522.515.515 0 00.45.263h19.72a.518.518 0 00.445-.784zm-10.305 3.89a3.609 3.609 0 002.839-1.383.424.424 0 00-.334-.688h-4.952a.453.453 0 00-.351.74l.003.003a3.606 3.606 0 002.795 1.328z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
));
